module.exports = "/static/media/instagram.503aeb23.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/instagram.svg
// module id = 1494
// module chunks = 0